import React, { createContext, useContext, useState, useMemo} from 'react';
import { BEPrismBuildingsContextType, BEPrismBuildingsContextProviderProps } from './types';
import { Building } from '../../helpers/integrations/BuildingEnginesPrism/client/buildings';

const BEPrismBuildingsContext = createContext<BEPrismBuildingsContextType | undefined>(undefined);

export const BEPrismBuildingsContextProvider = ({ children }: BEPrismBuildingsContextProviderProps) => {
  
  const [buildingId, setBuildingId] = useState<string>('');
  const [buildings, setBuildings] = useState<Building[]>([]);
  const [loadingBuildings, setLoadingBuildings] = useState(false);

  const value = useMemo(() => ({
    buildingId,
    setBuildingId,
    buildings,
    setBuildings,
    loadingBuildings,
    setLoadingBuildings,
  }), [buildingId, buildings, loadingBuildings]);

  return (
    <BEPrismBuildingsContext.Provider value={value}>
      {children}
    </BEPrismBuildingsContext.Provider>
  );
};

export const useBEPrismBuildingsContext = () => {
  const context = useContext(BEPrismBuildingsContext);

  if (!context) {
    throw new Error('useBEPrismBuildingsContext must be used within a BEPrismBuildingsContextProvider');
  }

  return context;
};